<template>
  <div id="app">
    <router-view />

  </div>
</template>

<script>

import { apiGetOpenId, apiGetAuthUrl } from "@/api/api"
export default {
  name: 'App',
  components: { },
  mounted() {
    // 判断是否在微信内
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf('micromessenger') != -1;
    // 判断是否在 微信内
    if(isWeixin){
      this.getCode()
      this.getUrlParam()
    }
  },
  methods: {
    // 获取地址的参数
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },

    // 强制关注公众号
    getCode(){
      if (localStorage.getItem("openid") && localStorage.getItem("openid")!="undefined") {
        return true;
      }
      let code = this.getUrlParam('code')
      let state = this.getUrlParam('state')
      if (code == null || code === '') {
        apiGetAuthUrl({
          redirect_url: window.location.href
        }).then(res=>{
          window.location.href = res
        })
      } else {
        this.getOpenId(code, state) //把code传给后台获取用户信息
      }
    },

    getOpenId(code, state){
      apiGetOpenId({
        code: code,
        state: state
      }).then(res=>{
        localStorage.setItem('opi', res.data)
      })
    }
  }
}
</script>

<style>
#app{
  height: 100%;
  overflow-x:hidden;
  background: #f8faff;
}
p{
  margin: 0
}
html{
  /*font-size: 100px!important;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue